import apiService from '@/api/apiService';
import { handleHttpError } from '@/api/errorHandler';

/**
 * 取得資產負債版本列表
 * @param {Object} params - 查詢參數
 * @param {string} [params.start_updated_at] - 開始更新時間 (YYYY-MM-DD)
 * @param {string} [params.end_updated_at] - 結束更新時間 (YYYY-MM-DD)
 * @param {number} [params.status] - 狀態（0=編輯中，1=完成）
 * @param {boolean} [params.requires_booking] - 是否需要預約
 * @param {number} [params.user_id] - 會員ID
 * @param {string} [params.internal_name] - 版本名稱(對內)
 * @param {boolean} [params.is_visible_user] - 是否對用戶可見
 * @param {number} [params.source] - 來源（0=學員，1=盤點人員，2=諮詢師）
 * @param {number} [params.net_asset_value_min] - 淨資產最小值
 * @param {number} [params.net_asset_value_max] - 淨資產最大值
 * @param {number} [params.monthly_cash_flow_min] - 月現金流最小值
 * @param {number} [params.monthly_cash_flow_max] - 月現金流最大值
 * @param {number} [params.page] - 頁碼
 * @param {number} [params.page_size] - 每頁顯示數量
 * @returns {Promise<Object>} API 回應
 */
export const getFinanceVersions = async (params = {}) => {
    try {
        // 直傳 params，apiService 會幫忙當作 query string
        const response = await apiService.GET('/api/admin/balance/versions', params);
        return response;
    } catch (error) {
        // 集中錯誤處理，附上上下文
        // 注意：handleHttpError 參數順序為 (error, url, method)
        throw handleHttpError(
            error,
            '/api/admin/balance/versions',
            'GET'
        );
    }
};